import type {
    AppAd,
    AppOpiniao,
    AppPost,
    AppTv24hItem,
} from '@/contentTypes';

type SitePost = {
    wpId: number;
    title: string;
    slug: string;
    excerpt: string | null;
    contentHtml: string | null;
    featuredImageUrl: string | null;
    authorName: string | null;
    authorImageUrl: string | null;
    publishedAt: string;
    updatedAt: string;
    categoryWpIds: number[];
    link: string;
};

type SiteOpiniao = {
    wpId: number;
    title: string;
    slug: string;
    contentHtml: string | null;
    quote: string | null;
    authorName: string | null;
    authorImageUrl: string | null;
    publishedAt: string;
    updatedAt: string;
    link: string;
};

type SiteTv = {
    wpId: number;
    title: string;
    slug: string;
    featuredImageUrl: string | null;
    url: string | null;
    publishedAt: string;
};

type SiteAd = {
    wpId: number;
    linkUrl: string | null;
    imageUrl: string | null;
    spotSlugs: string[];
    categoryWpIds: number[];
};

export function normalizePost(raw: SitePost): AppPost {
    return {
        id: raw.wpId,
        wpId: raw.wpId,
        title: raw.title,
        slug: raw.slug,
        excerpt: raw.excerpt,
        contentHtml: raw.contentHtml,
        featuredImageUrl: raw.featuredImageUrl,
        authorName: raw.authorName,
        authorImageUrl: raw.authorImageUrl,
        date: raw.publishedAt,
        publishedAt: raw.publishedAt,
        updatedAt: raw.updatedAt,
        categories: raw.categoryWpIds ?? [],
        categoryWpIds: raw.categoryWpIds ?? [],
        link: raw.link,
    };
}

export function normalizeOpiniao(raw: SiteOpiniao): AppOpiniao {
    return {
        id: raw.wpId,
        wpId: raw.wpId,
        title: raw.title,
        slug: raw.slug,
        contentHtml: raw.contentHtml,
        quote: raw.quote,
        authorName: raw.authorName,
        authorImageUrl: raw.authorImageUrl,
        date: raw.publishedAt,
        publishedAt: raw.publishedAt,
        updatedAt: raw.updatedAt,
        link: raw.link,
    };
}

export function normalizeTv(raw: SiteTv): AppTv24hItem {
    const image = raw.featuredImageUrl ?? '';
    const link = raw.url ?? '';
    return {
        id: raw.wpId,
        wpId: raw.wpId,
        title: raw.title,
        slug: raw.slug,
        featuredImageUrl: raw.featuredImageUrl,
        url: raw.url,
        image,
        link,
        date: raw.publishedAt,
        publishedAt: raw.publishedAt,
    };
}

export function normalizeAd(raw: SiteAd): AppAd {
    return {
        wpId: raw.wpId,
        linkUrl: raw.linkUrl,
        imageUrl: raw.imageUrl,
        link: raw.linkUrl ?? '',
        img: raw.imageUrl ?? '',
        spotSlugs: raw.spotSlugs ?? [],
        categoryWpIds: raw.categoryWpIds ?? [],
    };
}
